import React from "react";

import { Group, Select } from "@mantine/core";
import { IMeeting } from "@mctypes/meeting.types";
import { useHistory } from "react-router-dom";
import { CreateNewButton } from "../../../../components";
import { useAppSelector } from "../../../../hooks";
import { sortArrayByDate } from "../../../utils";
import { formatShortDate } from "../../admin/selectors";
import NewMeetingInSeriesModal from "../NewMeetingInSeriesModal";

const MeetingSeriesInstanceSelector: React.FC<{ singleMeeting: IMeeting.MeetingPopulated }> = ({ singleMeeting }) => {
  const meetingSerie = singleMeeting?.meetingSerie as IMeeting.MeetingSeriePopulated;
  const [newMeetingModalOpen, setNewMeetingModalOpen] = React.useState<boolean>(false);

  const project = useAppSelector((state) => state.adminReducer.project);

  const history = useHistory();
  const onChange = (_oldDate: IMeeting.MeetingPopulated, meetingObj: IMeeting.MeetingPopulated) => {
    history.replace(`/project/${project._id}/meetings/${meetingObj._id}`);
  };

  const connectedMeetings: IMeeting.MeetingPopulated[] = (meetingSerie?.connectedMeetingInstances || []).filter(
    (meeting) => meeting.isDeleted !== true,
  ) as IMeeting.MeetingPopulated[];

  const meetingOptions = sortArrayByDate(connectedMeetings, "dateOfMeeting").map((m) => ({
    value: m._id,
    label: formatShortDate(m.dateOfMeeting?.toString()),
  }));

  return (
    <Group gap="xs">
      <NewMeetingInSeriesModal
        meetingSerie={meetingSerie}
        opened={newMeetingModalOpen}
        onClose={() => setNewMeetingModalOpen(false)}
      />
      <Select
        size="sm"
        value={singleMeeting._id}
        data={meetingOptions}
        onChange={(val) => {
          const target = connectedMeetings.find((m) => m._id === val);
          if (target) {
            onChange(singleMeeting, target);
          }
        }}
        allowDeselect={false}
        w={140}
      />
      <CreateNewButton onClick={() => setNewMeetingModalOpen(true)} tooltip="Legg til nytt møte" size="sm" />
    </Group>
  );
};

export default MeetingSeriesInstanceSelector;
